import List from "@/components/list";
import vue from "@/main";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};

  // 移除班级教学内容表信息
  function removeTeachingContent(item) {
    vue.$emit("removeTeachingContent", item);
  }

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      ["icon-remove", "移除", () => removeTeachingContent(item), ""]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "图书名称",
      prop: "name",
      minWidth: "150",
      showOverflowTooltip: true
    },
    // {
    //   label: "状态",
    //   prop: "onlineStatusName",
    //   minWidth: "150",
    //   showOverflowTooltip: true
    // },
    {
      label: "操作",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      empty-text="尚未添加任何图书，点击右上角【图书管理】可进行图书添加"
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
